export const APP_VERSION = 'cb086c80-1790855094029'
